<template>
<v-dialog v-model="show" width="500">
  <v-card>
    <v-card-title>
      <span class="headline">{{title}}</span>
    </v-card-title>
    <v-card-actions>
      <v-btn :disabled="!allChoiced" @click="submit">{{$t('app.buttons.export')}}</v-btn>
      <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
    </v-card-actions>
    <v-card-text>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row wrap>
              <remote-autocomplete :label="$t('app.labels.bu.name')" :multiple="true" key="2" url="divisions/kv?type=BU" v-model="query.buId" />
            </v-layout>
            <v-layout row wrap v-if="warehouseShow">
              <remote-autocomplete label="BU" :multiple="true" key="2" url="divisions/kv?type=BUSINESS_UNIT" v-model="query.businessUnitId" />
            </v-layout>
            <v-layout row wrap>
              <remote-autocomplete :label="$t('B1300.labels.finallyWarehouseName')" :multiple="true" key="2" url="warehouses/kv" v-model="query.warehouseId" />
            </v-layout>
            <v-layout row wrap v-if="warehouseShow">
              <remote-autocomplete label="納入場所グループ" key="2" url="warehouse-groups/kv" v-model="query.groupId" />
            </v-layout>
            <v-layout row wrap v-if="warehouseShow">
              <remote-autocomplete label="品種名" :multiple="true" key="2" url="products/kv" v-model="query.productCode" />
            </v-layout>
            <v-layout row wrap v-if="!warehouseShow">
              <remote-autocomplete :multiple="true" label="コンテナ サイズ" url="container-types/kv" v-model="query.containerTypeId" />
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 pr-2>
                <date-picker :label="$t('app.labels.forecastDeliveryDate')" :max="query.to" :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]" v-model="query.from"></date-picker>
              </v-flex>
              <v-flex md6 pl-2>
                <date-picker :min="query.from" :rules="[v => !!v || $t('app.labels.forecastDeliveryDate') + $t('app.validator.messages.required')]" label="~" v-model="query.to"></date-picker>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  props: ['warehouseShow'],
  data() {
    return {
      title: '',
      show: false,
      query: {
        buId: null
      },
      resolve: null,
      reject: null
    }
  },
  computed: {
    allChoiced() {
      return (
        this.query.buId != null &&
        this.query.from != null &&
        this.query.to != null &&
        this.query.buId.length > 0
      )
    }
  },
  methods: {
    popup(title) {
      this.title = title
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
